import {
 computed, unref,
} from 'vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { IMapForFiltersSerpGetters, IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import maskRepository from '@ve/components/inputs/common/maskRepository';
import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';
import touristGroupText from '@ve/services/entities-services/tourists/touristGroupText';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import getSectionPricesFilter from '../services/getSectionPricesFilter';

const { useState, useGetters, useActions } = createNamespacedHelpers<IMapForFiltersSerpState, IMapForFiltersSerpGetters, IMapForFiltersSerpActions>(nameFilterSerpStore);

export default function () {
    const { getMinPriceHotel, getMaxPriceHotel } = useGetters(['getMinPriceHotel', 'getMaxPriceHotel']);
    const { touristGroup, maxPrice, minPrice } = useState(['touristGroup', 'maxPrice', 'minPrice']);
    const {
        action_maxPrice: updateMaxPrice,
        action_minPrice: updateMinPrice,
    } = useActions(['action_maxPrice', 'action_minPrice']);

    const minPriceFromInput = computed({
        get: () => (unref(minPrice) ? formatNumber(unref(minPrice) as number) : ''),
        set: (valueWithSpace) => {
            const value = Number(valueWithSpace.replace(/ /g, ''));
            updateMinPrice(value || null);
        },
    });
    const maxPriceFromInput = computed({
        get: () => (unref(maxPrice) ? formatNumber(unref(maxPrice) as number) : ''),
        set: (valueWithSpace) => {
            const value = Number(valueWithSpace.replace(/ /g, ''));
            updateMaxPrice(value || null);
        },
    });
    const resetMinPrice = () => {
        updateMinPrice(null);
    };
    const resetrMaxPrice = () => {
        updateMaxPrice(null);
    };

    const handlerSectionPrice = (price: number, isActive: boolean) => {
        if (isActive) {
            updateMaxPrice(null);
            return;
        }
        updateMaxPrice(price);
    };
    const countTouristGroup = computed(() => touristGroupText(unref(touristGroup), true));

    const minPricePlaceHolder = computed(() => formatNumber(unref(getMinPriceHotel)));

    const maxPricePlaceHolder = computed(() => formatNumber(unref(getMaxPriceHotel)));

    const sectionPrices = computed(() => getSectionPricesFilter(unref(getMinPriceHotel), unref(getMaxPriceHotel), 6));

    return {
        maxPrice,

        minPriceFromInput,
        maxPriceFromInput,

        minPricePlaceHolder,
        maxPricePlaceHolder,

        resetMinPrice,
        resetrMaxPrice,
        handlerSectionPrice,

        sectionPrices,
        touristGroup: countTouristGroup,

        maskRepository,
        formatNumber,
    };
}
